import React from 'react';
import styled from '@emotion/styled';
import { Col, Row, Space } from 'antd';
import {isNil} from "lodash";
const Wrapper = styled.div`
  padding: 8px;
  border: 1px solid #c4c8d0;
  border-radius: 4px;
  .ant-col:first-of-type {
    font-size: 12px;
    font-weight: 500;
    text-align: left;
  }
`;
const StyledRow = styled(Row)``;
const StyledColItem = styled(Col)`
  text-align: center;
  .ant-space-item {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: #232b3a;
  }
`;
const Block = styled.div`
  display: flex;
  width: 56px;
  height: 40px;
  border: 1px solid #c4c8d0;
  border-radius: 4px;
  background: #ebedef;
  justify-content: center;
  align-items: center;
`;
const TotalDefect: React.FC<{
  label: string;
  critical: number|null;
  major: number|null;
  minor: number|null;
}> = (props) => {
  return (
    <Wrapper>
      <StyledRow align={'middle'}>
        <Col span={6}>{props.label}</Col>
        <StyledColItem span={6}>
          <Space direction="vertical">
            Critical
            <Block>{isNil(props?.critical) ? "N/A": props?.critical}</Block>
          </Space>
        </StyledColItem>
        <StyledColItem span={6}>
          <Space direction="vertical">
            Major
            <Block>{isNil(props?.major) ? "N/A": props?.major}</Block>
          </Space>
        </StyledColItem>
        <StyledColItem span={6}>
          <Space direction="vertical">
            Minor
            <Block>{isNil(props?.minor)  ? "N/A": props?.minor}</Block>
          </Space>
        </StyledColItem>
      </StyledRow>
    </Wrapper>
  );
};

export default TotalDefect;
